import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import { isEmail, decode, encode, sendNotfication, wait, isPhoneValid1, isPhoneValid2 } from "../../../Helper";
import socket from "../../../Socket";
import C from "../../../Constant";
import Login from "./Login";

class Reset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: true,
            disabled: false,
            loginPage: false,
            email: '',
            r_code: '',
            password: ''
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentWillMount() {
        wait(500).then(() => {
            this.setState({ loading: false });
        })
    }

    componentDidMount() {
        socket.on(C.RESET_PASSWORD, data => this.resetPass(decode(data)));
    }

    handleShow(e) {
        this.props.clicked();
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
    }

    loginUser = (e) => {
        this.setState({ loginPage: !this.state.loginPage })
    };

    resetPass = (data) => {
        let response = data;

        const { t } = this.props;

        // console.log("some " +data);

        this.setState({ disabled: false });

        if (response.status) {
            this.loginUser();
            return sendNotfication(t('password successfully reset proceed to Login'), 'success', 'top-center');
        }
        else {
            return sendNotfication(t('An error occured'), 'warning', 'top-center');
        }
    };

    submitForm(e) {
        e.preventDefault();
        const { t } = this.props;

        if (!(isPhoneValid1(this.state.email) || isPhoneValid2(this.state.email))) {
            return sendNotfication(t('please enter valid mobile number'), 'warning', 'top-center');
        }

        this.setState({ disabled: true });

        wait(700).then(() => {


            socket.emit(C.RESET_PASSWORD, encode({
                email: this.state.email,
                r_code: this.state.r_code,
                password: this.state.password
            }));
        })
    }

    back = () => {
        this.props.clicked();
    };

    render() {
        let { justModal, t } = this.props;
        return (
            <>
                {this.state.loading && !justModal ?
                    <>
                        <div className="text-center">
                            <div class="spinner-border text-info my-3 user-loader" role="status" />
                        </div>
                    </>
                    :
                    <>
                        <div className="auth-form-container">
                            <div className="text-center mb-4">
                                <p className="text-white opacity-70">Enter the code sent to your phone to reset your password</p>
                            </div>
                            <form className="auth-form" onSubmit={(e) => this.submitForm(e)}>
                                <div className="auth-input-wrapper">
                                    <i className="mdi mdi-cellphone" />
                                    <input
                                        type="text"
                                        className="form-control auth-input-custom"
                                        name="email"
                                        placeholder="Mobile Number (07XX)"
                                        autoComplete="off"
                                        onChange={e => this.setState({ email: e.target.value })}
                                    />
                                </div>
                                <div className="auth-input-wrapper">
                                    <i className="mdi mdi-shield-check-outline" />
                                    <input
                                        type="text"
                                        className="form-control auth-input-custom"
                                        name="r_code"
                                        placeholder="Reset Code (XXXX)"
                                        autoComplete="off"
                                        onChange={e => this.setState({ r_code: e.target.value })}
                                    />
                                </div>
                                <div className="auth-input-wrapper">
                                    <i className="mdi mdi-lock-outline" />
                                    <input
                                        type="password"
                                        className="form-control auth-input-custom"
                                        name="password"
                                        placeholder="New Password"
                                        autoComplete="off"
                                        onChange={e => this.setState({ password: e.target.value })}
                                    />
                                </div>
                                <div className="mt-4">
                                    <button type="submit" className="auth-btn-primary" disabled={this.state.disabled}>
                                        {this.state.disabled ? (
                                            <><i className="mdi mdi-loading mdi-spin mr-2" /> Resetting...</>
                                        ) : (
                                            <><i className="mdi mdi-key-variant mr-2" /> Reset Password</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                }
                {
                    this.state.loginPage &&
                    <Login t={t} justModal="true" />
                }
            </>
        );
    }
}

export default Reset;